import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ConnectFormDirective } from './connect-form/connect-form.directive'
import { PatchFormGroupValuesDirective } from './patch-form-group-values/patch-form-group-values.directive'
import { S3FileDirective } from './s3-file/s3-file.directive'
import { CheckboxValueDirective } from './checkbox-value/checkbox-value.directive'
import { NumbersOnlyDirective } from './numbers-only/numbers-only.directive'
import { InfiniteScrollTriggerDirective } from './infinite-scroll-trigger/infinite-scroll-trigger.directive'
import { MatStepperScrollToTopDirective } from './mat-stepper-scroll-to-top/mat-stepper-scroll-to-top.directive'
import { FocusInputDirective } from './focus-input/focus-input.directive'
import { GbRouteNewTabDirective } from './gb-route-new-tab/gb-route-new-tab.directive'
import { MatButtonLoadingDirective } from './mat-button-loading/mat-button-loading.directive'
import { DisableNumberSpinnerDirective } from './disable-number-spinner/disable-number-spinner.directive'
import { NgSelectRequiredDirective } from './ng-select-required/ng-select-required.directive'
import { NgSelectNoopSearchDirective } from './ng-select-noop-search/ng-select-noop-search.directive'
import { FormControlObjectDirective } from './form-control-object-directive/form-control-object.directive'
import { NgSelectDialogDirective } from './ng-select-dialog-directive/ng-select-dialog.directive'
import { SwiperInitDirective } from './swiper-init/swiper-init.directive'
import { register } from 'swiper/element/bundle'

register()

@NgModule({
  imports: [CommonModule],
  declarations: [
    ConnectFormDirective,
    PatchFormGroupValuesDirective,
    S3FileDirective,
    CheckboxValueDirective,
    NumbersOnlyDirective,
    InfiniteScrollTriggerDirective,
    MatStepperScrollToTopDirective,
    FocusInputDirective,
    GbRouteNewTabDirective,
    MatButtonLoadingDirective,
    DisableNumberSpinnerDirective,
    NgSelectRequiredDirective,
    NgSelectNoopSearchDirective,
    NgSelectDialogDirective,
    FormControlObjectDirective,
    SwiperInitDirective,
  ],
  exports: [
    ConnectFormDirective,
    PatchFormGroupValuesDirective,
    S3FileDirective,
    CheckboxValueDirective,
    NumbersOnlyDirective,
    InfiniteScrollTriggerDirective,
    MatStepperScrollToTopDirective,
    FocusInputDirective,
    GbRouteNewTabDirective,
    MatButtonLoadingDirective,
    DisableNumberSpinnerDirective,
    NgSelectRequiredDirective,
    NgSelectNoopSearchDirective,
    NgSelectDialogDirective,
    FormControlObjectDirective,
    SwiperInitDirective,
  ],
})
export class SharedUtilsDirectivesModule {}
